<template>
  <Card theme="flat" tag="form" class="image-marker-edit" @submit.prevent="submit">
    <template #default>
      <InputComponent :label="$t('edit')">
        <Leaflet
          :controllers="['circle', 'rectangle', 'polygon']"
          v-if="value"
          v-model="coordinates"
          :options="{ preferCanvas: true }"
          :image="value.url"
          :getStyle="leafletStyle"
          ref="leaflet"
          @add="add"
        />
      </InputComponent>
    </template>
    <template #footer>
      <slot name="footer" />
      <ButtonComponent
        type="submit"
        :label="$t('confirm')"
        theme="primary"
        :promise="promise"
        :success-label="$t('completed')"
        @onSuccess="$emit('close')"
      />
    </template>
  </Card>
</template>

<script>
import toImage from '@/components/Leaflet/plugins/toImage'

import Card from '@/components/Card'
import Leaflet from '@/components/Leaflet'
import { VueComponentUpload as upload } from '@kvass/storage'
import { InputComponent } from 'vue-elder-input'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    show: Boolean,
  },
  watch: {
    value: {
      handler: 'reset',
      immediate: true,
    },
  },
  data() {
    return {
      coordinates: [],
      promise: null,
    }
  },
  methods: {
    upload,
    add(layer) {
      this.coordinates.push(layer)
    },
    submit() {
      /** ? Adding dimensions will create a factor calculation, but the markers as shifted down right */
      const dimensions = this.$refs.leaflet.dimensions
      this.promise = toImage(this.$refs.leaflet.map)
        .then(file => this.upload(file, () => {}, { compression: 'gallery' }))
        .then(res => this.$emit('input', { ...res, name: this.value.name }))
    },
    reset() {
      this.coordinates = []
    },
    leafletStyle() {
      return {
        weight: 2,
        color: '#FF0000',
        fillColor: '#FF0000',
        fillOpacity: 0,
        opacity: 1,
      }
    },
  },

  components: {
    Leaflet,
    Card,
    InputComponent,
  },
}
</script>

<style lang="scss">
.image-marker-edit {
  max-width: 1000px;
  width: 100%;

  @include respond-below('tablet') {
    .card__content,
    .card__footer {
      padding: 0.5rem;
    }
  }
}
</style>
